import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

type UpsertCustomInput = ClientInferResponseBody<
  typeof contract.quoteRequestLines.upsertCustomInput
>;

type UpsertCustomInputDto = ClientInferRequest<
  typeof contract.quoteRequestLines.upsertCustomInput
>["body"];

export const upsertCustomInput = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpsertCustomInputDto;
}): Promise<UpsertCustomInput> => {
  const response = await api.quoteRequestLines.upsertCustomInput.mutation({
    params: {
      id,
    },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to create CustomInput", response.status, response.body);
};
